module.exports = __webpack_public_path__ + "img/T80.1d0133df.jpg";